import { IdentityDocumentType } from '../domain/types';

export const identityDocumentTypeLabels: Record<IdentityDocumentType, string> = {
  IDENTITY_CARD: 'Carta di identità',
  PASSPORT: 'Passaporto',
  DRIVER_LICENSE: 'Patente di guida',
};
